import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DeviceService } from 'app/services/device.service';

@Component({
  selector: 'app-agent-conversation-shadow',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './agent-conversation-shadow.component.html',
  styleUrl: './agent-conversation-shadow.component.scss'
})
export class AgentConversationShadowComponent {
  isAppleMobile: boolean = false;

  constructor(private deviceService: DeviceService) {
    this.isAppleMobile = this.deviceService.isAppleDevice();
  }
}
